// extracted by mini-css-extract-plugin
module.exports = {"checkboxesContainer":"CreateEditClinics_checkboxesContainer__hEwgD","emails":"CreateEditClinics_emails__p-oUy","emailTagLabel":"CreateEditClinics_emailTagLabel__3JWx_"};